import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=67a62cde&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a62cde')) {
      api.createRecord('67a62cde', component.options)
    } else {
      api.reload('67a62cde', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=67a62cde&", function () {
      api.rerender('67a62cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tpc7p8uUx4W3/JS/imageCarousel.vue"
export default component.exports